<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formClick" :formData="formData"></FORM>
    <table-page ref="childTable" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE ref="sourceUpdate" @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
import tablePage from '@/components/page/table.vue'
import FORM from '@/components/page/form.vue'
import DateUtil from '@/utils/IM/tradeDataUtil.js'
import Qs from 'qs'
import Url from '@/views/merchandiser/util/url'
import UPDATE from '@/components/page/update'

let types = { 1: '新进信号源', 2: '历史信号源', 3: '不合格信号源' },//信号源属性
  userType = { 1: '代理', 2: '標準', 3: '行家', 4: '大師', 5: '傳奇' },
  approveStatus = { 0: '剛申請', 1: '啟用', 2: '拒絕' },
  companyCodeName = {}, company = {},
  platformList = { 'GTS2': 'GTS2', 'MT5': 'MT5' }

export default {
  name: 'list',
  components: {
    tablePage,
    FORM,
    UPDATE
  },
  mounted() {

  },
  created() {
    this.initCompanys()
  },
  methods: {
    initCompanys() {
      this.dataChange(Url.company.companyListAll, {}, res => {
        if (res.code == 0) {
          for (let i in res.result) {
            companyCodeName[res.result[i].companyId] = res.result[i].name
            company[res.result[i].companyId] = res.result[i]
          }
        } else {
          this.$message.error('加載公司列表失敗')
        }
      })
    },
    /*查询表单按钮点击事件*/
    formClick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        this.queryData = data
        this.$refs.childTable.defaultQueryData(data)
      } else if ('新增' == clickName) {
        this.$refs.sourceUpdate.open()
      }
    },
    submit(model) {
      model.allowedPlatform = model.allowedPlatform.join(',')
      this.dataChange(Url.signal.sourceApplyAdd, model, res => {
        if (res.code == 0) {
          this.$refs.sourceUpdate.close()
          this.$message.success('操作成功')
          this.$refs.childTable.defaultQueryData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    },
    bthClick(clickName, row) {
      if (clickName == 'approve') {
        row.status = 1
        this.status(row)
      } else if (clickName == 'refuse') {
        row.status = 2
        this.status(row)
      }
    },
    status(row) {
      this.dataChange(Url.signal.sourceApplyStatus, row, res => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.$refs.childTable.defaultQueryData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    bussinessType(model) {
      let assigningCompanyId = model.assigningCompanyId
      let result = {}
      if (assigningCompanyId != undefined && assigningCompanyId != null) {
        let businessTypes = company[assigningCompanyId].businessTypes.split(',')
        for (const i in businessTypes) {
          result[businessTypes[i]] = businessTypes[i]
        }
      }
      return result
    }
  },
  data() {
    return {
      queryData: {},
      updateData: {
        cols: [
          { title: 'id', field: 'id', hidden: true },
          { title: '信号源交易账号', field: 'customerNumber' },
          {
            title: '信号源所属公司',
            field: 'companyId',
            required: true,
            type: 2,
            optionList: companyCodeName,
            isNumber: true
          },
          { title: '信号源所屬平臺', field: 'platform', required: true, type: 2, optionList: platformList, data: [] },
          { title: '信号源所屬业务', field: 'businessType' },
          {
            title: '指派公司',
            field: 'assigningCompanyId',
            required: true,
            type: 2,
            optionList: companyCodeName
          },

          {
            title: '指派业务',
            field: 'assigningBusinessType',
            required: true,
            type: 2,
            optionListObjRender: (model, col) => {
              return this.bussinessType(model)
            }
          },
          { title: '初始跟單人數', field: 'initTrack', required: true },
          { title: '最多允许跟单人数', field: 'maxTrack', required: true },
          { title: '支持平台', field: 'allowedPlatform', required: true, type: 4, optionList: platformList, data: [] },
          { title: 'UI端昵称', field: 'nickName', required: true },
          { title: '头像', field: 'imgUrl', required: true },
          { title: '信号源类型', field: 'userType', required: true, type: 2, optionList: userType },
          { title: '利润分成', field: 'profitSharing', required: true, isNumber: true },
          { title: '简介', field: 'remark' }
        ]
      },
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          { title: '信号源賬號', field: 'customerNumber' },
          { title: '信号源所属公司', field: 'companyId', isNumber: true },
          { title: '信号源所属业务', field: 'businessType' },
          { title: '指派公司', field: 'assigningCompanyId', isNumber: true },
          { title: '指派业务', field: 'assigningBusinessType' },
          { click: window.$t('common.search') },
          { click: '新增', auth: 'source:apply:add' }
        ]
      },
      /*table生成*/
      pageData: {
        isShow: false,
        queryUrl: Url.signal.sourceApplyList,
        selection: false,
        sequence: true,
        size: 10,
        method: 'get',
        cols: [
          { title: '信号源交易账号', field: 'customerNumber' },
          { title: '信号源所属公司', field: 'companyId' },
          { title: '信号源所属业务', field: 'businessType' },
          { title: '指派公司', field: 'assigningCompanyId' },
          { title: '指派业务', field: 'assigningBusinessType' },
          { title: '允许跟单人数', field: 'maxTrack' },
          { title: '初始跟单人数', field: 'initTrack' },
          {
            title: '是否启用', field: 'status', render: (data, full) => {
              return approveStatus[data]
            }
          },
          {
            title: '信号源类型', field: 'userType', render: (data, full) => {
              return userType[data]
            }
          },
          { title: '利润分成', field: 'profitSharing' },
          { title: '審批人', field: 'approvalUser' },
          {
            title: '審批時間', field: 'approvalTime', render: (data, full) => {
              if (data > 0) {
                return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
              }
              return null
            }
          },
          { title: '創建人', field: 'createUser' },
          {
            title: '創建時間', field: 'createTime', render: (data, full) => {
              if (data > 0) {
                return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
              }
              return null
            }
          },
          {
            title: '操作',
            btnClick: [
              {
                name: '通過',
                click: 'approve',
                type: 'primary',
                icon: 'el-icon-add',
                auth: 'source:apply:approve',
                hidden: (model, col) => {
                  return col.status == 0 ? false : true
                }
              },
              {
                name: '拒絕',
                click: 'refuse',
                type: 'primary',
                icon: 'el-icon-delete',
                auth: 'source:apply:refuse',
                hidden: (model, col) => {
                  return col.status == 0 ? false : true
                }
              }]
          }
        ]
      }
    }
  }
}
</script>
